module.exports = __webpack_public_path__ + "img/cara-contenta.09f7a390.svg";